<!-- Add navigation menu bar -->
<div class="share-bottom-btn px-3 py-2 d-flex justify-content-between w-100">
    <button
        [ngClass]="{'opacity-50': ((!(isLoggedIn$ | async) || !navigator.onLine) && currentRouteFragment !== DBC_SCREENS.LEAD_LIST)}"
        class="btn-bottom-nav d-flex flex-column text-light px-0"
        (click)="handleNavigation(DBC_SCREENS.LEAD_LIST)"
        style="width: 56px;"
    >
        <div
            class="mx-auto rounded-circle share-card-icon d-flex justify-content-center align-items-center"
        >
            <img
                class="icon-size"
                alt="Leads"
                src="/img/icons/list-icon.svg"
            />
        </div>
        <p class="mb-0">Contacts</p>
    </button>
    <button
        class="btn-bottom-nav mx-auto d-flex flex-column text-light px-0"
        [ngClass]="{ 'opacity-50': disableShareCardOption || ((!(isLoggedIn$ | async) || !navigator.onLine) && currentRouteFragment !== DBC_SCREENS.CARDS) }"
        [disabled]="disableShareCardOption"
        (click)="handleNavigation(DBC_SCREENS.CARDS)"
    >
        <div
            class="mx-auto rounded-circle share-card-icon d-flex justify-content-center align-items-center"
        >
            <img
                class="icon-size"
                alt="ShareCard"
                src="/icons/dbc/share-light.svg"
            />
        </div>
        <p class="mb-0 text-nowrap">Share Card</p>
    </button>
    <button
        [ngClass]="{ 'opacity-50' : ((!(isLoggedIn$ | async) || !navigator.onLine) && currentRouteFragment !== DBC_SCREENS.CAPTURE)}"
        class="btn-bottom-nav d-flex flex-column text-light px-0"
        style="width: 56px;"
        (click)="handleNavigation(DBC_SCREENS.CAPTURE)"
    >
        <div
            class="mx-auto rounded-circle share-card-icon d-flex justify-content-center align-items-center"
        >
            <img
                class="icon-size"
                alt="Capture"
                src="/img/icons/capture-icon.svg"
            />
        </div>
        <p class="mb-0">Capture</p>
    </button>
</div>
